import { taskRailRoutes } from '@modules/Tasks/Resources/js/utils/taskRailRoutes';

export default {
    slug: 'products',
    ability: 'products',
    routes: [
        {
            path: 'products',
            name: 'product-list',
            component: () => import('@modules/Products/Resources/js/pages/List.vue'),
            children: [
                {
                    path: ':id(\\d+)',
                    name: 'product-preview',
                    component: () => import('@modules/Products/Resources/js/pages/Preview.vue'),
                    redirect: { name: 'product-overview' },
                    props: true,
                    children: [
                        {
                            path: '/organization/:org/products/:id(\\d+)',
                            name: 'product-overview',
                            component: () => import('@modules/Products/Resources/js/pages/preview/Overview.vue'),
                            props: true
                        },
                        {
                            path: 'pictures',
                            name: 'product-pictures',
                            component: () => import('@/components/base/tabs/TabPictures.vue'),
                            props: true
                        },
                        {
                            path: 'suppliers',
                            name: 'product-suppliers',
                            component: () => import('@modules/Products/Resources/js/pages/preview/suppliers/Panel.vue'),
                            props: true
                        },
                        {
                            path: 'stock',
                            name: 'product-stock',
                            component: () => import('@modules/Products/Resources/js/pages/preview/stock/Panel.vue'),
                            props: true
                        },
                        {
                            path: 'comments',
                            name: 'product-comments',
                            component: () => import('@/components/base/tabs/TabComments.vue'),
                            props: true
                        },
                        {
                            path: 'tasks',
                            name: 'product-tasks',
                            component: () => import('@/components/base/tabs/TabTasks.vue'),
                            props: true,
                            children: taskRailRoutes('product-tasks')
                        },
                        {
                            path: 'logs',
                            name: 'product-logs',
                            component: () => import('@/components/base/tabs/TabLogs.vue'),
                            props: true
                        },
                        {
                            path: 'documents/:docPath(.*)*',
                            name: 'product-documents',
                            component: () => import('@/components/base/tabs/TabDocuments.vue'),
                            props: true
                        }
                    ]
                }
            ]
        }
    ],
    portalRoutes: [
        {
            path: 'store',
            name: 'portal-store',
            component: () => import('@modules/Products/Resources/js/portal/Store.vue')
        },
        {
            path: 'store/:id(\\d+)',
            name: 'portal-product-detail',
            component: () => import('@modules/Products/Resources/js/portal/StoreProductDetail.vue'),
            props: true
        },
        {
            path: 'cart',
            name: 'portal-cart',
            component: () => import('@modules/Products/Resources/js/portal/Cart.vue')
        },
        {
            path: 'checkout',
            name: 'portal-checkout',
            component: () => import('@modules/Products/Resources/js/portal/Checkout.vue')
        }
    ],
    nav: () => ({
        section: 'inventory',
        items: [
            {
                position: 3,
                title: i18n.t('Products'),
                icon: 'coffee-outline',
                to: { name: 'product-list' }
            }
        ]
    })
};
